module.exports = __webpack_public_path__ + "img/temp_pub_3.c185a9a5.jpg";